<ef-sync-dialog-presenter
    [FromPeriodSelectItems]="fromPeriods"
    [ToPeriodSelectItems]="fromPeriods"
    (onOk)="ref.close($event)"
    (onCancel)="ref.close()"
></ef-sync-dialog-presenter>
